import { useAuth } from '../hooks/useAuth';
import { RemoteSessionListener } from './RemoteSessionListener';

export function RemoteSessionGuard() {
  const { user } = useAuth();

  if (!user?.id) return null;

  return <RemoteSessionListener userId={user.id} />;
}
